<div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{colorName}}</span>
    <input type="text" pInputText placeholder="Hex Color" [(ngModel)]="value" [pKeyFilter]="'hex'" minlength="6" maxlength="8" [disabled]="isDisabled">
    <p-colorPicker [(ngModel)]="value" appendTo="body" [disabled]="isDisabled"></p-colorPicker>
</div>
<div class="description-text">{{description}}</div>
<!--<div *ngIf="color.errors?.minlength">Min length error</div>-->
